import { MDText } from 'i18n-react';

import { RedWarningTriangleIcon } from '@motorway/motorway-storybook-cra';

import texts from 'Components/texts.json';

import styles from './ErrorOverlay.module.scss';

const LocalT = new MDText(texts);

export const ErrorOverlay: React.FC = () => (
	<div className={styles.container}>
		<div className={styles.message}>
			<RedWarningTriangleIcon className={styles.warningTriangle} />
			<span>{LocalT.translate('vehicleDetails.location.mapLoadingError')}</span>
		</div>
	</div>
);
